export default __webpack_public_path__ + "static/media/dumpster-rental.fc291565.svg";